// The only way to mutate the internal state is to dispatch an action.
// The actions can be serialized, logged or stored and later replayed.
// store.dispatch({ type: "counter/incremented" });
// {value: 1}
// store.dispatch({ type: "counter/incremented" });
// {value: 2}
// store.dispatch({ type: "counter/decremented" });
// {value: 1}

// ACTIONS

export const setRecipes = (keys) => ({
  type: 'SET_RECIPES',
  keys,
})

export const swapRecipe = (index, key) => ({
  type: 'SWAP_RECIPE',
  index,
  key,
})
